(function () {
  function openPurchaseModal() {
    var modal = document.getElementById('purchaseModal');
    if (!modal) return;
    modal.classList.add('show');
  }

  function closePurchaseModal() {
    var modal = document.getElementById('purchaseModal');
    if (!modal) return;
    modal.classList.remove('show');
  }

  function phoneInputs() {
    return document.querySelectorAll('.purchase-phone');
  }

  function inputWraps() {
    return document.querySelectorAll('.purchase-verification__input-wrap');
  }

  function messages() {
    return document.querySelectorAll('.verification-message');
  }

  function shiprocketDivs() {
    return document.querySelectorAll('.shiprocket-headless[data-gurugram-verification]');
  }

  function setVerifiedAll(verified) {
    window.__phGurugramPhoneVerified = verified;

    inputWraps().forEach(function (wrap) {
      wrap.classList.toggle('is-verified', verified);
    });

    shiprocketDivs().forEach(function (div) {
      div.classList.toggle('disabled', !verified);
    });

    document.querySelectorAll('.sticky-shiprocket-trigger').forEach(function (btn) {
      btn.classList.toggle('disabled', !verified);
    });
  }

  function setMessageAll(text) {
    messages().forEach(function (message) {
      message.innerText = text;
    });
  }

  function initPurchaseVerification() {
    window.__phGurugramPhoneVerified = false;
    sessionStorage.removeItem('purchase-verification-phone');
    sessionStorage.removeItem('purchase-verification-verified');

    var verifyBtns = document.querySelectorAll('.purchase-btn');
    if (shiprocketDivs().length === 0 && verifyBtns.length === 0) return;

    var isSyncing = false;

    function syncPhoneValue(value, source) {
      isSyncing = true;
      phoneInputs().forEach(function (input) {
        if (input !== source) {
          input.value = value;
        }
      });
      isSyncing = false;
    }

    phoneInputs().forEach(function (input) {
      input.value = '';
    });
    setVerifiedAll(false);
    setMessageAll('');

    phoneInputs().forEach(function (input) {
      input.addEventListener('input', function (e) {
        if (isSyncing) return;

        setVerifiedAll(false);
        syncPhoneValue(e.target.value, e.target);
        setMessageAll('');
      });
    });

    document.addEventListener('ph:checkout-blocked', function () {
      setMessageAll('Please verify your mobile number before Buy Now.');
    });

    document.addEventListener('ph:checkout-error', function (event) {
      if (event.detail && event.detail.message) {
        setMessageAll(event.detail.message);
      }
    });

    verifyBtns.forEach(function (verifyBtn) {
      verifyBtn.addEventListener('click', async function () {
        var phone = phoneInputs()[0]?.value.trim() ?? '';

        if (!/^[6-9]\d{9}$/.test(phone)) {
          setVerifiedAll(false);
          setMessageAll('Please enter a valid mobile number.');
          return;
        }

        setVerifiedAll(false);
        setMessageAll('Checking...');

        try {
          var response = await fetch(
            'https://lavender-crane-371749.hostingersite.com/api/orders/has-milk-purchase?phoneNumber=' +
              encodeURIComponent(phone)
          );
          var data = await response.json();

          if (data.success) {
            setVerifiedAll(false);
            setMessageAll('');
            openPurchaseModal();
          } else {
            setVerifiedAll(true);
            setMessageAll('');
          }
        } catch (err) {
          console.error(err);
          setVerifiedAll(false);
          setMessageAll('Something went wrong. Please try again.');
        }
      });
    });
  }

  function initPurchaseModal() {
    var modal = document.getElementById('purchaseModal');
    if (!modal) return;

    var closeBtn = document.querySelector('.purchase-modal-close');
    var closeModalBtn = document.getElementById('closePurchaseModal');

    if (closeBtn) closeBtn.addEventListener('click', closePurchaseModal);
    if (closeModalBtn) closeModalBtn.addEventListener('click', closePurchaseModal);

    window.addEventListener('click', function (e) {
      if (e.target === modal) {
        closePurchaseModal();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPurchaseVerification();
    initPurchaseModal();
  });
})();
